import { getContentInfoWindowsStop, mouseoverEvent, mouseoutEvent, mouseClickEvent, getContentInfoWindowsHistorical, getContentInfoForFilters, getContentInfoForLastReport, getContentInfoWindowsForFailure, mouseLeaveEvent, mouseEnterEvent } from '../../features/core/components/Map/index';
import { Marker, PointsOfInterest, Geofence } from '../../features/core/models';
import { HistoricalDtcInfo } from './api/LastReportDtcs';
import { formatDate } from '../../features/core/utils';

/* Recibo un marker y un infowindow
   Le agrega un event listener al contenido de un marcador para el mouseover/mouseout
   porque marker.addEventListener solo funciona con click
*/
export const attachMarkerListeners = (
    marker: google.maps.marker.AdvancedMarkerElement,
    infowindow?: google.maps.InfoWindow,
    customListenerType?:string,
    customListener?: (event: Event) => void
) => {
    if (marker.content) {
        let content:Node = marker.content;
        let newDivWithUpdatedContent: HTMLElement = document.createElement('div');
        newDivWithUpdatedContent.classList.add('marker-content-listener');
        newDivWithUpdatedContent.appendChild(content);
        newDivWithUpdatedContent.style.cursor = 'pointer';
        marker.content = newDivWithUpdatedContent;

        if (customListener && customListenerType) {
            newDivWithUpdatedContent.addEventListener(customListenerType, customListener);
            return
        }

        if(infowindow){
            let mouseoutTimeout: NodeJS.Timeout;

            newDivWithUpdatedContent.addEventListener(mouseoverEvent, () => {
                clearTimeout(mouseoutTimeout);
                infowindow.open(marker.map, marker);
            });
    
            newDivWithUpdatedContent.addEventListener(mouseoutEvent, () => {
                mouseoutTimeout = setTimeout(() => {
                    infowindow.close();
                }, 150);
            });
        }
    }
};

export const getInfoWindow = (
    content: string, 
    position?: google.maps.LatLng,
    pixelOffset?:google.maps.Size | null

): google.maps.InfoWindow => {
    /* Infowindow constructor */
    let pixOffset = new google.maps.Size(0, -10);
    if(pixelOffset){
        pixOffset = pixelOffset;
    }
    return new google.maps.InfoWindow({
        content: content,
        disableAutoPan: true,
        ...(position ? { position: position } : {}),
        pixelOffset: pixOffset
    });
}

export const getInfoWindowForStop = (
    marker: google.maps.marker.AdvancedMarkerElement,
    start_date: string,
    end_date:string
) : google.maps.InfoWindow => {
    /* Infowindow de una Parada - Recorridos */
    let infowindow = getInfoWindow(getContentInfoWindowsStop(new Date(start_date), new Date(end_date)))
    marker.zIndex = 8;
    attachMarkerListeners(marker, infowindow);
    return infowindow;
}

export const getInfoWindowForDTCFailure = (
    dtc: HistoricalDtcInfo,
    vehicleDescription:string,
    marker: google.maps.marker.AdvancedMarkerElement
) : google.maps.InfoWindow => {
    /* Infowindow de un DTC (Falla) - Recorridos */
    let infowindow = getInfoWindow(getContentInfoWindowsForFailure(
            formatDate(dtc.timestamp, true), 
            dtc.description,
            vehicleDescription,
    ))
    marker.zIndex = 8;
    attachMarkerListeners(marker, infowindow);
    return infowindow
}

   
export const getInfoForFilters = (marker: Marker, position?: google.maps.LatLng): google.maps.InfoWindow => {
    /* Infowindow de un filtro - recorridos*/
    return getInfoWindow(getContentInfoForFilters(marker), position);
}

export const getInfoForLastReport = (
    marker: Marker, 
    isMDPUser: boolean = false
): google.maps.InfoWindow => {
    /* Infowindow vehiculo - Last Report */
    return getInfoWindow(
        getContentInfoForLastReport(marker, isMDPUser)
    )
}

export const getPointsOfInterestInfo = (point: PointsOfInterest): google.maps.InfoWindow => {
    /* Infowindow - Punto de Interes */
    let content = pointOfInterestInfoContent(point);
    return getInfoWindow(content)
}

export const pointOfInterestInfoContent = (point: PointsOfInterest):string => {
    return `<div id="content"><span class='black-description'>${point.description}</span>`;
}

export const getGeofenceInfo = (geoFence: Geofence, geofenceTypeName:string): google.maps.InfoWindow => {
    /* Infowindow - Geocerca */
    let content = `<div id="content"><span class='black-description'>${geoFence.description}</span> <span class='fs-13'>- ${geofenceTypeName}</span>` 
    return getInfoWindow(content)
}



